/* eslint-disable no-underscore-dangle */
/* eslint-disable consistent-return */
/* eslint-disable default-case */
import axios, { AxiosRequestConfig } from 'axios';
// @ts-ignore
import { Service } from 'axios-middleware';
import enviroment from '../enviroments';
import axiosInstance from './axiosServicesLogin';

const service = new Service(axios);

const createAxiosInstances = () => {
  const config: AxiosRequestConfig = {
    baseURL: enviroment.API_URL_USERS,
    params: {
      cc: '056d1622-4ade-42da-ab38-7126dbca8e0e',
    },
  };

  return axios.create(config);
};

const axiosDefault = createAxiosInstances();

service.register({
  async onResponseError(error: any) {
    const originalRequest = error.config;

    if (error.response.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        try {
          const token = await new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject });
          });
          originalRequest.headers.Authorization = `Bearer ${token}`;
          return await axios(originalRequest);
        } catch (err) {
          return Promise.reject(err);
        }
      }

      originalRequest._retry = true;
      isRefreshing = true;

      return new Promise((resolve, reject) => {
        const toJson = localStorage.getItem('@token');
        const datas = toJson == null ? null : JSON.parse(toJson);

        axiosInstance.get(`/admin/conta-usuario/v1/refresh-token?refreshToken=${datas.refreshToken}`)
          .then(({ data }) => {
            const dataToRefres = {
              token: data?.token?.access_token,
              refreshToken: data?.token?.refresh_token,
            };

            localStorage.setItem('@token', JSON.stringify(dataToRefres));

            axios.defaults.headers.common.Authorization = `Bearer ${data?.token?.access_token}`;
            originalRequest.headers.Authorization = `Bearer ${data?.token?.access_token}`;
            processQueue(null, data?.token?.access_token);
            resolve(axios(originalRequest));
          })
          .catch((err) => {
            processQueue(err, null);
            reject(err);
          })
          .finally(() => { isRefreshing = false; });
      });
    }

    return Promise.reject(error);
  },
});

const requesSuccessHandler = (value: any) => {
  const toJson = localStorage.getItem('@token');
  const datas = toJson == null ? null : JSON.parse(toJson);

  if (datas.token) {
    value.headers = { Authorization: `Bearer ${datas.token}` };
  }
  return value;
};

const requestErrorHandler = (error: any) => error;

axiosDefault.interceptors.request.use(async (conf) => conf);

axiosDefault.interceptors.request.use(
  requesSuccessHandler,
  requestErrorHandler,
);
let isRefreshing = false;
// @ts-ignore
let failedQueue = [];

const processQueue = (error: any, token = null) => {
  // @ts-ignore
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

export default axiosDefault;
